module.exports = __webpack_public_path__ + "img/assassin.db4ef457.png";